export default [
  {
    path: '/weekday-types',
    name: 'weekday-type',
    meta: { requiresAuth: true },
    component: () => import('@/pages/weekday-type/table.vue')
  }
]
